import { useState } from "react";
import OutletSearch from "../SelectSearch/OutletSearch";
import HeatmapView from "./HeatmapView";
import TableLayoutEditor from "./TableLayoutEditor";
import Navbar from "../Navbar";
import Footer from "../Footer";

export default function TableAnalyticsPage() {
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const token = localStorage.getItem("token");
    const [viewMode, setViewMode] = useState("heatmap");

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow mb-8">
                <div className="p-3">
                    <div className="flex justify-between items-center max-w-5xl mx-auto">
                        <div className="flex-1 flex justify-start" />

                        <div className="flex-1 flex justify-center">
                            <OutletSearch
                                selectedOutlet={selectedOutlet}
                                setSelectedOutlet={setSelectedOutlet}
                                token={token}
                                compact={true}
                            />
                        </div>

                        <div className="flex flex-1 justify-end">
                            <div className="flex justify-center">
                                <div className="inline-flex rounded-md border bg-white p-1">
                                    <button
                                        onClick={() => setViewMode("heatmap")}
                                        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${viewMode === "heatmap"
                                            ? "bg-slate-600 text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                            }`}
                                    >
                                        Heatmap
                                    </button>

                                    <button
                                        onClick={() => setViewMode("layout")}
                                        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${viewMode === "layout"
                                            ? "bg-slate-600 text-white"
                                            : "text-gray-700 hover:bg-gray-100"
                                            }`}
                                    >
                                        Table Layout
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Views */}
                    {viewMode === "heatmap" ? (
                        <HeatmapView selectedOutlet={selectedOutlet} token={token} />
                    ) : (
                        <TableLayoutEditor selectedOutlet={selectedOutlet} token={token} />
                    )}

                </div>
            </div>

            <Footer />
        </div>
    );
}
